import script from "./sidebarView.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebarView.vue?vue&type=script&setup=true&lang=js"

import "./sidebarView.vue?vue&type=style&index=0&id=bb7985ba&scoped=true&lang=css"

import exportComponent from "E:\\Source\\HuasCo\\personal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb7985ba"]])

export default __exports__